import clsx from 'clsx';

interface ILabel {
  text: string;
  htmlFor?: string;
  error?: boolean;
  errorText?: string;
}
export default function Label({ text, htmlFor, error, errorText }: ILabel) {
  return (
    <label
      htmlFor={htmlFor}
      className={clsx(
        'text-primary text-12 cursor-pointer mb-2 leading-1 flex gap-2 justify-between'
      )}
    >
      {text}
      {error && <span className={'text-red'}>{errorText}</span>}
    </label>
  );
}
